import { render, staticRenderFns } from "./BidCreateFromAuction.vue?vue&type=template&id=4ca72c9e"
import script from "./BidCreateFromAuction.vue?vue&type=script&lang=js"
export * from "./BidCreateFromAuction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports